import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

function App() {
  return (
    <>
    < Navbar/>
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
